import { render, staticRenderFns } from "./RetirosSocios.vue?vue&type=template&id=723394e6&"
import script from "./RetirosSocios.vue?vue&type=script&lang=js&"
export * from "./RetirosSocios.vue?vue&type=script&lang=js&"
import style0 from "./RetirosSocios.vue?vue&type=style&index=0&id=723394e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports